
export const sType = {
  NONE: "NONE",
  PORTAIR: "PORT_AIR",
  DOORAIR: "DOOR_AIR",
  CONSOLIDATIONAIR: "CONSOLIDATION_AIR",
  PORTSEA: "PORT_SEA",
  DOORSEA: "DOOR_SEA",
  CONSOLIDATIONSEA: "CONSOLIDATION_SEA",
  DOORCOURIER: "DOOR_COURIER",
  DOORLAND: "DOOR_LAND"
}

const EnquiryHelper = {

  stringGenerator: (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  },

  getService: (qd) => {
    var service_total = {}
    service_total["air_port_delivery"] = (qd.quote_air?.length && qd.quote_air[0]?.final?.port_delivery?.port_grant_total) ? qd.quote_air[0]?.final?.port_delivery?.port_grant_total : "Not Applicable"
    service_total["air_door_delivery"] = (qd.quote_air?.length && qd.quote_air[0]?.final?.door_delivery?.door_grant_total) ? qd.quote_air[0]?.final?.door_delivery?.door_grant_total : "Not Applicable"
    service_total["air_consolidation_delivery"] = (qd.quote_air?.length && qd.quote_air[0]?.final?.consolidation_delivery?.consolidation_grant_total) ? qd.quote_air[0]?.final?.consolidation_delivery?.consolidation_grant_total : "Not Applicable"

    service_total["sea_port_delivery"] = (qd.quote_sea?.length && qd.quote_sea[0]?.final?.port_delivery?.port_grant_total) ? qd.quote_sea[0]?.final?.port_delivery?.port_grant_total : "Not Applicable"
    service_total["sea_door_delivery"] = (qd.quote_sea?.length && qd.quote_sea[0]?.final?.door_delivery?.door_grant_total) ? qd.quote_sea[0]?.final?.door_delivery?.door_grant_total : "Not Applicable"
    service_total["sea_consolidation_delivery"] = (qd.quote_sea?.length && qd.quote_sea[0]?.final?.consolidation_delivery?.consolidation_grant_total) ? qd.quote_sea[0]?.final?.consolidation_delivery?.consolidation_grant_total : "Not Applicable"

    service_total["courier_door_delivery"] = (qd.quote_courier?.length && qd.quote_courier[0]?.final?.door_delivery?.door_grant_total) ? qd.quote_courier[0]?.final?.door_delivery?.door_grant_total : "Not Applicable"
    service_total["courier_port_delivery"] = (qd.quote_courier?.length && qd.quote_courier[0]?.final?.port_delivery?.port_grant_total) ? qd.quote_courier[0]?.final?.port_delivery?.port_grant_total : "Not Applicable"
    service_total["land_door_delivery"] = (qd.quote_land?.length && qd.quote_land[0]?.final?.door_delivery?.door_grant_total) ? qd.quote_land[0]?.final?.door_delivery?.door_grant_total : "Not Applicable"
    service_total["land_port_delivery"] = (qd.quote_land?.length && qd.quote_land[0]?.final?.port_delivery?.port_grant_total) ? qd.quote_land[0]?.final?.port_delivery?.port_grant_total : "Not Applicable"
    service_total["land_consolidation_delivery"] = (qd.quote_land?.length && qd.quote_land[0]?.final?.consolidation_delivery) ? qd.quote_land[0]?.final?.consolidation_delivery?.consolidation_grant_total : "Not Applicable"

    return service_total;
  },

  getAmountFreight: (value, detail) => {

    for (let key in sType) {
      if (value === "NONE" || detail.selected_courier_type === "NONE") {
        return { withDiscount: 0, withoutDiscount: 0 };
      } else {
        if (value === key || detail.selected_courier_type === key) {
          let indexofText = sType[key].search("_")
          let index = sType[key].length - indexofText
          let sTypeLastName = sType[key].slice(sType[key].length - index + 1, sType[key].length);
          let sTypeFirstName = sType[key].slice(0, indexofText);
          let quote = `quote_${sTypeLastName.toLowerCase()}`;
          let delivery = `${sTypeFirstName.toLowerCase()}_delivery`;
          let withDiscounttotal = `discount_${sTypeFirstName.toLowerCase()}_grant_total`;
          let withoutDiscounttotal = `${sTypeFirstName.toLowerCase()}_grant_total`;
          if (detail[quote]?.length && (detail[quote][0]?.final[delivery][withDiscounttotal] || (detail[quote]?.length && detail[quote][0]?.final[delivery][withoutDiscounttotal]))) {
            let resultObj = { withDiscount: detail[quote]?.length && detail[quote][0]?.final[delivery][withDiscounttotal], withoutDiscount: detail[quote]?.length && detail[quote][0]?.final[delivery][withoutDiscounttotal] }
            return resultObj;
          }
        }
      }
    }
  },

  getFreightamount: (value, detail) => {
    // console.log(myVar.slice(myVar.length - 3, myVar.length));

    if (value === "NONE" || detail.selected_courier_type === "NONE") {
      return 0;
    }

    /// air
    if (value === "PORTAIR" || detail.selected_courier_type === "PORTAIR") {
      return (detail.quote_air?.length && detail.quote_air[0]?.final?.port_delivery?.discount_port_grant_total) ? detail.quote_air[0]?.final?.port_delivery?.discount_port_grant_total : "0"
    }

    if (value === "DOORAIR" || detail.selected_courier_type === "DOORAIR") {
      return (detail.quote_air?.length && detail.quote_air[0]?.final?.door_delivery?.discount_door_grant_total) ? detail.quote_air[0]?.final?.door_delivery?.discount_door_grant_total : "0"
    }

    if (value === "CONSOLIDATIONAIR" || detail.selected_courier_type === "CONSOLIDATIONAIR") {
      return (detail.quote_air?.length && detail.quote_air[0]?.final?.consolidation_delivery?.discount_consolidation_grant_total) ? detail.quote_air[0]?.final?.consolidation_delivery?.discount_consolidation_grant_total : "Not Applicable"
    }

    /// sea
    if (value === "PORTSEA" || detail.selected_courier_type === "PORTSEA") {
      return (detail.quote_sea?.length && detail.quote_sea[0]?.final?.port_delivery?.discount_port_grant_total) ? detail.quote_sea[0]?.final?.port_delivery?.discount_port_grant_total : "0"
    }

    if (value === "DOORSEA" || detail.selected_courier_type === "DOORSEA") {
      return (detail.quote_sea?.length && detail.quote_sea[0]?.final?.door_delivery?.discount_door_grant_total) ? detail.quote_sea[0]?.final?.door_delivery?.discount_door_grant_total : "0"
    }

    if (value === "CONSOLIDATIONSEA" || detail.selected_courier_type === "CONSOLIDATIONSEA") {
      return (detail.quote_sea?.length && detail.quote_sea[0]?.final?.consolidation_delivery?.discount_consolidation_grant_total) ? detail.quote_sea[0]?.final?.consolidation_delivery?.discount_consolidation_grant_total : "Not Applicable"
    }

    // courier

    if (value === "DOORCOURIER" || detail.selected_courier_type === "DOORCOURIER") {
      return (detail.quote_courier?.length && detail.quote_courier[0]?.final?.door_delivery?.discount_door_grant_total) ? detail.quote_courier[0]?.final?.door_delivery?.discount_door_grant_total : "0"
    }

    // land

    if (value === "DOORLAND" || detail.selected_courier_type === "DOORLAND") {
      return (detail.quote_land?.length && detail.quote_land[0]?.final?.door_delivery?.discount_door_grant_total) ? detail.quote_land[0]?.final?.door_delivery?.discount_door_grant_total : "0"
    }

  },


  /// for insurance calculation
  insuranceCalculation: (grandAmount, itemsValue, insuranceData) => {

    let insuranceAmount = 0;
    insuranceData &&
    // eslint-disable-next-line
      insuranceData.map((item) => {
        insuranceAmount +=
          ((Number(grandAmount) + Number(itemsValue)) *
            item.insurance_premium) /
          100;
      });
    return Number(insuranceAmount);
  },

  /// for storage calculation
  storageCalculation: (strVal, storageArray, volumestateItems) => {
    if (storageArray) {
      let cbmRate = 0,
        handleIn = 0,
        handleOut = 0;

      storageArray &&
      // eslint-disable-next-line
        storageArray.map((item) => {
          if (item.tarrif === "storage_charges") {
            cbmRate = +item.rate;
          }
          if (item.tarrif === "handling_in") {
            handleIn = +item.rate;
          }
          if (item.tarrif === "handling_out") {
            handleOut = +item.rate;
          }
        });

      let datavol = volumestateItems.volume;
      const totalStorage =
        Number(strVal) * cbmRate +
        (Number(handleIn) * Number(datavol) +
          Number(handleOut) * Number(datavol));
      return Math.round(totalStorage);
    }
  },

  validationRequoteTable: (validator, generalDetailsObj) => {
    let TableField;
    TableField = + validator.current.fieldValid("Destination") &&
      validator.current.fieldValid("Origin") &&
      validator.current.fieldValid("Description") &&
      validator.current.fieldValid("Package") &&
      validator.current.fieldValid("Kilogram") &&
      validator.current.fieldValid("Length") &&
      validator.current.fieldValid("Weight") &&
      validator.current.fieldValid("Height") &&
      validator.current.fieldValid("Shipment Value");
    // validator.current.fieldValid("Customer Service");

    if (
      generalDetailsObj.retailer_name &&
      generalDetailsObj.retailer_name !== "None"
    ) {
      TableField = + validator.current.fieldValid("Referral Code") &&
        validator.current.fieldValid("Sales Person Name") &&
        validator.current.fieldValid("Destination") &&
        validator.current.fieldValid("Origin") &&
        validator.current.fieldValid("Description") &&
        validator.current.fieldValid("Package") &&
        validator.current.fieldValid("Kilogram") &&
        validator.current.fieldValid("Length") &&
        validator.current.fieldValid("Weight") &&
        validator.current.fieldValid("Height") &&
        validator.current.fieldValid("Shipment Value");
      // validator.current.fieldValid("Customer Service");
    }
    return TableField;
  },

  validationRequoteFilter: (validator, generalDetailsObj) => {
    let filterValidate;

    filterValidate = +
      validator.current.fieldValid("Destination") &&
      validator.current.fieldValid("Origin") &&
      validator.current.fieldValid("filter") &&
      validator.current.fieldValid("quantity") &&
      validator.current.fieldValid("Shipment Value") &&
      validator.current.fieldValid("Customer Service");
    if (
      generalDetailsObj.retailer_name &&
      generalDetailsObj.retailer_name !== "None"
    ) {
      filterValidate =
        +validator.current.fieldValid("Referral Code") &&
        validator.current.fieldValid("Sales Person Name") &&
        validator.current.fieldValid("Customer Service") &&
        validator.current.fieldValid("Destination") &&
        validator.current.fieldValid("Origin") &&
        validator.current.fieldValid("Description") &&
        validator.current.fieldValid("quantity") &&
        validator.current.fieldValid("Kilogram") &&
        validator.current.fieldValid("Length") &&
        validator.current.fieldValid("Weight") &&
        validator.current.fieldValid("Height") &&
        validator.current.fieldValid("Shipment Value");
    }
    return filterValidate;
  },

  validationQuoteTable: (validator, generalDetailsObj) => {
    let quoteTablevalid;

    quoteTablevalid = + validator.current.fieldValid("Customer Number") &&
      validator.current.fieldValid("Customer Type") &&
      validator.current.fieldValid("Customer Email") &&
      validator.current.fieldValid("Customer Name") &&
      validator.current.fieldValid("Destination") &&
      validator.current.fieldValid("Origin") &&
      validator.current.fieldValid("Description") &&
      validator.current.fieldValid("Package") &&
      validator.current.fieldValid("Kilogram") &&
      validator.current.fieldValid("Length") &&
      validator.current.fieldValid("Weight") &&
      validator.current.fieldValid("Height") &&
      validator.current.fieldValid("Customer Service") &&
      validator.current.fieldValid("Confirmed") &&
      validator.current.fieldValid("Service Type") &&
      validator.current.fieldValid("Shipment Value");
    if (
      generalDetailsObj.retailer_name &&
      generalDetailsObj.retailer_name !== "None"
    ) {
      quoteTablevalid = +
        validator.current.fieldValid("Referral Code") &&
        validator.current.fieldValid("Sales Person Name") &&
        validator.current.fieldValid("Customer Number") &&
        validator.current.fieldValid("Customer Type") &&
        validator.current.fieldValid("Customer Email") &&
        validator.current.fieldValid("Customer Name") &&
        validator.current.fieldValid("Destination") &&
        validator.current.fieldValid("Origin") &&
        validator.current.fieldValid("Description") &&
        validator.current.fieldValid("Package") &&
        validator.current.fieldValid("Kilogram") &&
        validator.current.fieldValid("Length") &&
        validator.current.fieldValid("Weight") &&
        validator.current.fieldValid("Height") &&
        validator.current.fieldValid("Customer Service") &&
        validator.current.fieldValid("Confirmed") &&
        validator.current.fieldValid("Service Type") &&
        validator.current.fieldValid("Shipment Value");
    }
    return quoteTablevalid;
  },

  validationQuoteFilter: (validator, generalDetailsObj) => {

    console.log(
      validator.current.fieldValid("Referral Code") ,
      validator.current.fieldValid("Sales Person Name") ,
      validator.current.fieldValid("Customer Number") ,
      validator.current.fieldValid("Customer Type") ,
      validator.current.fieldValid("Customer Email") ,
      validator.current.fieldValid("Customer Name") ,
      validator.current.fieldValid("Destination") ,
      validator.current.fieldValid("Origin") ,
      validator.current.fieldValid("quantity") ,
      validator.current.fieldValid("Customer Service") ,
      validator.current.fieldValid("Confirmed") ,
      validator.current.fieldValid("Service Type") ,
      validator.current.fieldValid("Shipment Value")
    )

    let quoteValidate;

    quoteValidate = + validator.current.fieldValid("Customer Number") &&
      validator.current.fieldValid("Customer Type") &&
      validator.current.fieldValid("Customer Email") &&
      validator.current.fieldValid("Customer Name") &&
      validator.current.fieldValid("Destination") &&
      validator.current.fieldValid("Origin") &&
      validator.current.fieldValid("quantity") &&
      validator.current.fieldValid("Customer Service") &&
      validator.current.fieldValid("Confirmed") &&
      validator.current.fieldValid("Service Type") &&
      validator.current.fieldValid("Shipment Value");
    if (
      generalDetailsObj.retailer_name &&
      generalDetailsObj.retailer_name !== "None"
    ) {
      quoteValidate = +
        validator.current.fieldValid("Referral Code") &&
        validator.current.fieldValid("Sales Person Name") &&
        validator.current.fieldValid("Customer Number") &&
        validator.current.fieldValid("Customer Type") &&
        validator.current.fieldValid("Customer Email") &&
        validator.current.fieldValid("Customer Name") &&
        validator.current.fieldValid("Destination") &&
        validator.current.fieldValid("Origin") &&
        validator.current.fieldValid("quantity") &&
        validator.current.fieldValid("Customer Service") &&
        validator.current.fieldValid("Confirmed") &&
        validator.current.fieldValid("Service Type") &&
        validator.current.fieldValid("Shipment Value");
    }
    return quoteValidate;
  },

  proceedObject: (data) => {
    let objectData = {
      retailer_id: data.generalDetailsObj.retailer_id,
      customer_details: {
        name: data.customerName,
        email: data.email,
        mobile_number: data.Phonenumber,
        user_type: data.usertype && data.usertype.label,
      },
      shipment_details: {
        origin: data.OrginValue.city,
        destination: data.DestinationValue.city,
        value_of_goods: data.goodValue,
        shipment_type: "NONE",
        shipment_mode: data.deliverytype || data.selectedValue,
        servic_type: data.deliverytype || data.selectedValue,
      },
      payment_information: {
        quotation_number: data.quotedData && data.quotedData._id,
        booking_amount: data.finalFreightAmount || 0,
        actual_amount: data.actualAmount,
        agreed_amount: 0,
        payment_status: data.getDetails.payment_status || "",
        discount_amount: data.discountAmount
      },
      general_details: {
        retailer_name: data.generalDetailsObj.retailer_name,
        retailer_id: data.generalDetailsObj.retailer_id,
        referral_code: data.generalDetailsObj.referral_code,
        sales_person: data.generalDetailsObj.sales_person,
        promo_code: data.generalDetailsObj.promo_code,
        customer_service: data.generalDetailsObj.customer_service,
        customer_name: data.customerName,
        overseas_agent: "",
        customer_type: "",
        end_customer_type: "",
        shipment_category: "",
      },
      sender_details: {
        pickup: [
          {
            sender_name: "",
            pickup_contact: "",
            address: "",
            email: "",
            delevered_by: "",
            invoice_number: "",
          },
        ],
        comments: "",
      },

      receiver_details: {
        receiver_name: "",
        pickup_contact: "",
        email: "",
        address: "",
        comments: "",
      },
      cargo_details: {
        comments: "",
        booking_value_of_goods: data.goodValue,
        actual_value_of_goods: data.goodValue,
      },
      add_ons: {
        packing: data.packingJson,
        insurance: data.insuranceValue,
        storage: data.storageValue,
        comments: "",
      },

      carrier_details: {
        m_awb_m_b_l: "",
        m_awb_h_b_l: "",
        carrier_name: "",
        port_of_entry: data.portEntry,
        shipment_type: data.deliverytype,
        comments: "",
      },

      revenue: {
        booking_ref: "",
        account_name: "",
        advance_amount: "",
        final_amount: data.finalFreightAmount,
        discount: data.percentageValue,
        remark: "",
        comments: "",
      },
      enquiry_details: {
        follow_up_date: data.followUpdate,
      },
      added_by: {
        user_id: data.getDetails.user_id,
        quote_by_id: data.getDetails._id,
        quote_by: data.getDetails.quote_by,
      },
      quote_token: data.getDetails && data.getDetails.quote_token,
      insurance: data.insurance,
      storage: data.storage,
      packingCharge: data.packingCharge,
      freight: data.freight,
      bookingAmount: data.bookingAmount,
      quote_token: data.quote_token,
      discount_amount: data.discountAmount
    }

    return objectData;
  },

  subTotalfun: (tp, ti, ts) => {
    let totalSub = Number(tp ? tp : 0) + Number(ti ? ti : 0) + Number(ts ? ts : 0);
    return totalSub;
  },

  proceedValidation: (validator, generalDetailsObj) => {
    let proceedValid;
    proceedValid = + validator.current.fieldValid("Customer Type") &&
      validator.current.fieldValid("Customer Email") &&
      validator.current.fieldValid("Customer Name") &&
      validator.current.fieldValid("Destination") &&
      validator.current.fieldValid("Origin") &&
      validator.current.fieldValid("Shipment Value") &&
      validator.current.fieldValid("Service Type") &&
      validator.current.fieldValid("Confirmed") &&
      validator.current.fieldValid("Customer Service");
    if (
      generalDetailsObj.retailer_name &&
      generalDetailsObj.retailer_name !== "None"
    ) {
      validator.current.fieldValid("Customer Type") &&
        validator.current.fieldValid("Customer Email") &&
        validator.current.fieldValid("Customer Name") &&
        validator.current.fieldValid("Destination") &&
        validator.current.fieldValid("Origin") &&
        validator.current.fieldValid("Shipment Value") &&
        validator.current.fieldValid("Service Type") &&
        validator.current.fieldValid("Sales Person Name") &&
        validator.current.fieldValid("Customer Service");
      validator.current.fieldValid("Referral Code") &&
        validator.current.fieldValid("Confirmed");
    }
    return proceedValid;
  },

  minDate: (currentDate) => {
    var today = currentDate;
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }

    return today = yyyy + "-" + mm + "-" + dd;
  },

  getDiscountbyPercentage: (percentageCode, totaldeliver) => {
    let percentageAmount = 0;
    if (percentageCode) {
      percentageAmount = (Number(totaldeliver) * Number(percentageCode)) / 100;
    }
    return percentageAmount
  },

  validationEnquiryAddedTable: (validator, generalDetailsObj) => {
    let TableField = 0;

    TableField +=
      validator.current.fieldValid('Customer Number') &&
      validator.current.fieldValid('Customer Type') &&
      validator.current.fieldValid('Customer Email') &&
      validator.current.fieldValid('Customer Name') &&
      validator.current.fieldValid('Destination') &&
      validator.current.fieldValid('Origin') &&
      validator.current.fieldValid('Description') &&
      validator.current.fieldValid('Package') &&
      validator.current.fieldValid('Kilogram') &&
      validator.current.fieldValid('Length') &&
      validator.current.fieldValid('Weight') &&
      validator.current.fieldValid('Height') &&
      validator.current.fieldValid('Customer Service') &&
      validator.current.fieldValid('Shipment Value');
    if (
      generalDetailsObj.retailer_name &&
      generalDetailsObj.retailer_name !== 'None'
    ) {
      TableField +=
        validator.current.fieldValid('Customer Number') &&
        validator.current.fieldValid('Customer Type') &&
        validator.current.fieldValid('Customer Email') &&
        validator.current.fieldValid('Customer Name') &&
        validator.current.fieldValid('Destination') &&
        validator.current.fieldValid('Origin') &&
        validator.current.fieldValid('Description') &&
        validator.current.fieldValid('Package') &&
        validator.current.fieldValid('Kilogram') &&
        validator.current.fieldValid('Length') &&
        validator.current.fieldValid('Weight') &&
        validator.current.fieldValid('Height') &&
        validator.current.fieldValid('Customer Service') &&
        validator.current.fieldValid('Shipment Value') &&
        validator.current.fieldValid('Referral Code') &&
        validator.current.fieldValid('Sales Person Name') &&
        validator.current.fieldValid('Promo Code');
    }

    return TableField;
  },

  validationEnquiryAddedFilter: (validator, generalDetailsObj) => {
    let FilterField = 0;

    console.log(validator.current.fieldValid('Customer Number') ,
    validator.current.fieldValid('Customer Type') ,
    validator.current.fieldValid('Customer Email') ,
    validator.current.fieldValid('Customer Name') ,
    validator.current.fieldValid('Destination') ,
    validator.current.fieldValid('Origin') ,
    validator.current.fieldValid('quantity') ,
    validator.current.fieldValid('Customer Service') ,
    validator.current.fieldValid('Shipment Value'),
    validator.current.fieldValid('Sales Person Name')
    )

    FilterField +=
      validator.current.fieldValid('Customer Number') &&
      validator.current.fieldValid('Customer Type') &&
      validator.current.fieldValid('Customer Email') &&
      validator.current.fieldValid('Customer Name') &&
      validator.current.fieldValid('Destination') &&
      validator.current.fieldValid('Origin') &&
      validator.current.fieldValid('quantity') &&
      validator.current.fieldValid('Customer Service') &&
      validator.current.fieldValid('Shipment Value');
    if (
      generalDetailsObj.retailer_name &&
      generalDetailsObj.retailer_name !== 'None'
    ) {
      FilterField +=
        validator.current.fieldValid('Customer Number') &&
        validator.current.fieldValid('Customer Type') &&
        validator.current.fieldValid('Customer Email') &&
        validator.current.fieldValid('Customer Name') &&
        validator.current.fieldValid('Destination') &&
        validator.current.fieldValid('Origin') &&
        validator.current.fieldValid('quantity') &&
        validator.current.fieldValid('Customer Service') &&
        validator.current.fieldValid('Shipment Value') &&
        validator.current.fieldValid('Referral Code') &&
        validator.current.fieldValid('Sales Person Name') ;
        // && validator.current.fieldValid('Promo Code');
    }

    return FilterField;
  }

}

export default EnquiryHelper;


